"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserHeader = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var BrowserHeader = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 4v16s0 2 2 2h18c2 0 2-2 2-2V4c0-2-2-2-2-2H3S1 2 1 4zm20 15a1 1 0 01-1 1H4a1 1 0 01-1-1V9a1 1 0 011-1h16a1 1 0 011 1v10zM4 6a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0zm2 1a1 1 0 100-2 1 1 0 000 2z", clipRule: "evenodd" }),
    react_1.default.createElement("path", { fill: "currentColor", d: "M19 12a1 1 0 01-1 1H6a1 1 0 01-1-1v-1a1 1 0 011-1h12a1 1 0 011 1v1z", opacity: "0.72" }))); };
exports.BrowserHeader = BrowserHeader;
//# sourceMappingURL=browser-header.js.map